import {
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  SupportRadioIcon,
  SupportTvIcon,
  Typography,
} from '@acceso/design-system';
import { useMemo } from 'react';

import { RenderEnrichementsIcons } from '@/components/RenderEnrichementsIcons/RenderEnrichementsIcons';
import { StartTimeEndTimePart } from '@/components/StartTimeEndTimePart/StartTimeEndTimePart';
import { StatusSeenChipInTable } from '@/components/StatusSeenChipInTable';
import { SEGMENT_REVIEW_STATES } from '@/constants';
import { useChannelId } from '@/features/broadcasters/api/get-channel-id';

import { TSegment } from '../../types';

type SegmentsDetailHeaderInfoProps = {
  segment?: TSegment | null;
  showEnrichments?: boolean;
  hideUriName?: boolean;
};

export function SegmentsDetailHeaderInfo({
  segment,
  showEnrichments,
  hideUriName,
}: SegmentsDetailHeaderInfoProps) {
  const { data: channel } = useChannelId({ id: segment?.channel_id || '' });

  const uriName = useMemo(() => {
    const partes = segment?.uri?.split('-') || '';
    const ultimaParte = partes[partes?.length - 1];
    return ultimaParte;
  }, [segment?.uri]);

  if (!segment) return <></>;

  return (
    <div className="flex w-fit flex-1 flex-wrap items-center gap-2">
      {segment?.media_type === 'tvts' ? <SupportTvIcon /> : <SupportRadioIcon />}
      <StatusSeenChipInTable
        item={segment}
        review_state={segment?.review_state || 0}
        reviewStates={SEGMENT_REVIEW_STATES}
      />
      <Typography
        fontSize={FontSizeEnum.Sm}
        color={FontColorEnum.Medium}
        weight={FontWeightEnum.Semibold}
      >
        {channel?.name}
      </Typography>
      {!hideUriName && (
        <Typography
          fontSize={FontSizeEnum.Sm}
          color={FontColorEnum.Medium}
          weight={FontWeightEnum.Regular}
        >
          {uriName}
        </Typography>
      )}
      <StartTimeEndTimePart
        startDateTime={segment?.start_datetime}
        endDateTime={segment?.end_datetime}
      />
      {segment?.audience !== null && (
        <Typography
          fontSize={FontSizeEnum.Sm}
          color={FontColorEnum.Medium}
          weight={FontWeightEnum.Regular}
        >
          {segment.audience || '-'} /{' '}
          {segment.audience_rating_percent ? segment.audience_rating_percent.toFixed(2) : '0.00'} %
        </Typography>
      )}
      {showEnrichments && (
        <RenderEnrichementsIcons
          classname="ml-12"
          iconClassname="text-accent-medium-primary-20"
          enrichments={{
            ocr: channel?.parameters?.enrichments?.ocr,
            stt: channel?.parameters?.enrichments?.stt,
            logos: channel?.parameters?.enrichments?.logos,
            peoples: channel?.parameters?.enrichments?.peoples,
            advertising: channel?.parameters?.enrichments?.advertising,
          }}
        />
      )}
    </div>
  );
}
